export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/util/eventConsts.js
// module id = 719
// module chunks = 7